import a from "./index808.js";
import s from "./index926.js";
import l from "./index846.js";
function d(e, t, m) {
  for (var i = -1, n = t.length, o = {}; ++i < n; ) {
    var r = t[i], f = a(e, r);
    m(f, r) && s(o, l(r, e), f);
  }
  return o;
}
export {
  d as default
};
